import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Shooping Ibirapuera/ibirapuera.jpg';
import imagem2 from '../assets/images/Projetos/Shooping Ibirapuera/ibirapuera2.jpg';
import imagem3 from '../assets/images/Projetos/Shooping Ibirapuera/ibirapuera3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Shopping Ibirapuera",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
    "O Shopping Ibirapuera é um dos principais shoppings da Grande São Paulo, nos projetos ligados a ele, atuamos diretamente com:",
    solutions: ["Solução de Cobertura Indoor"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;